import { BtnSmallModule } from './../../../../../shared/btn-small/btn-small.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppWebcamComponent } from './app-webcam/app-webcam.component';
import { WebcamModule } from 'ngx-webcam';

@NgModule({
  declarations: [AppWebcamComponent],
  imports: [CommonModule, WebcamModule, BtnSmallModule],
  exports: [AppWebcamComponent],
})
export class IdentificacaoModule {}
